import src from "IMAGE";
export default { src, width: 185, height: 168, blurWidth: 0, blurHeight: 0};
